<template>
  <div class="PageContainer mt-xs pb-lg d-flex w-100 justify-space-center" v-if="booking">
    <div class="content w-100 d-flex flex-column gap-lg">
      <div>
        <div v-if="booking.status === 'pending' || (booking.status === 'accepted' && getPending())">
          <BookingDetailCard :booking="booking" :type="booking.status" />
        </div>
        <div v-if="
          booking.status === 'accepted' &&
          contract &&
          contract.status === 'signed_by_tenant_and_owner' &&
          inWithinDays(dayjs(booking.startDate).add(3, 'day').format(), 3) &&
          !isChecked
        " class="mt-xs">
          <BookingDetailCard :type="'check-in'" :booking="booking" />
        </div>
        <div v-if="
          booking.status === 'accepted' &&
          isChecked &&
          contract &&
          contract.status === 'signed_by_tenant_and_owner' &&
          inWithinDays(booking.endDate, 15) &&
          !isCheckedOut
        " class="mt-xs">
          <BookingDetailCard :type="'check-out'" :booking="booking" />
        </div>
        <div v-if="contract?.status == 'signed_by_owner'" class="mt-xs">
          <ContractDetailCard :contract="contract" :booking-id="booking.id as string" />
        </div>
      </div>
      <div>
        <div v-if="rentalUnit">
          <RentalUnitCard :status="booking.status as string"
            :name="getCurrentName(rentalUnit as RentalUnit, languageSelected) as string" :image="getCoverImage(
              rentalUnit.Images.length > 0
                ? rentalUnit.Images
                : (rentalUnit.Property?.Images as Photos[]),
            )
              " :rental-unit="rentalUnit" />
        </div>
      </div>

      <div>
        <h1 class="font-md blue-darker bold-medium mb-xs">{{ t('bookingDetails.datesOf') }}</h1>

        <ion-card class="border-default no-shadow rental-card ion-no-margin bg-white" color="light">
          <ion-row class="ba-grey pa-xs border-default">
            <ion-col size="6" class="ion-no-padding">
              <p class="subtitle grey">{{ t('search.arrival') }}</p>
              <div class="d-flex align-center">
                <ion-icon :icon="calendarClearOutline" color="grey"></ion-icon>
                <p class="padding-list-item">
                  {{ formatDateTime(booking?.startDate as string, locale, true, true) }}
                </p>
              </div>
            </ion-col>
            <ion-col size="6" class="ion-no-padding">
              <p class="subtitle grey">{{ t('search.departure') }}</p>
              <div class="d-flex align-center">
                <ion-icon :icon="calendarClearOutline" color="grey"></ion-icon>
                <p class="padding-list-item">
                  {{ formatDateTime(booking?.endDate as string, locale, true, true) }}
                </p>
              </div>
            </ion-col>
          </ion-row>
        </ion-card>

        <ion-card
          class="border-default no-shadow ion-no-margin mt-xs d-flex justify-space-between results-card bg-white"
          color="light">
          <ion-list class="ion-no-padding" :inset="true">
            <ion-item button @click="
              router.push({ name: 'reservationDocuments', params: { bookingId: booking.id } })
              ">
              <ion-icon slot="start" color="grey" :icon="documentTextOutline" size="small"></ion-icon>
              <ion-label>
                <p class="padding-list-item font-xs">{{ t('booking.documents.title') }}</p>
                <p class="padding-list-item font-xs bold-normal">
                  {{ t('booking.documents.description') }}
                </p>
              </ion-label>
            </ion-item>
            <ion-item v-if="booking.status === 'accepted'" button @click="router.push({ name: 'Billing' })">
              <div v-if="getPending()" class="pending-circle"></div>
              <ion-icon slot="start" color="grey" :icon="cardOutline" size="small"></ion-icon>
              <ion-label>
                <p class="padding-list-item font-xs">{{ t('invoices.paymentsAnd') }}</p>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-card>

        <!-- Agregamos nueva card para botón chat -->
        <ion-card
          class="border-default no-shadow ion-no-margin mt-xs d-flex justify-space-between results-card bg-white"
          color="light">
          <ion-list class="ion-no-padding" :inset="true">
            <ion-item button @click="
              router.push({ name: 'Chat', params: { bookingId: booking.id }, query: { user: 'owner' } })">
              <ion-icon slot="start" color="grey" :icon="chatbubblesOutline" size="small"></ion-icon>
              <ion-label>
                <p class="padding-list-item font-xs">{{ t('booking.botonChat.title') }}</p>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-card>

      </div>

      <div>
        <h1 class="font-md blue-darker bold-medium mb-xs">{{ t('booking.bookingData') }}</h1>

        <ion-card class="border-default no-shadow rental-card ion-no-margin bg-white" color="light">
          <ion-row class="ba-grey pa-xs border-default">
            <ion-col v-if="booking.Owner && booking.Owner.fullName" size="12" class="ion-no-padding mb-xs">
              <p class="subtitle grey">{{ t('booking.host') }}</p>
              <div class="d-flex align-center">
                <p class="font-sm bold-medium">
                  {{ booking.Owner.fullName }}
                </p>
              </div>
            </ion-col>
            <ion-col v-if="rentalUnit && rentalUnit.Rate" size="6" class="ion-no-padding">
              <p class="subtitle grey">{{ t('booking.rent') }}</p>
              <div class="d-flex align-center">
                <p class="font-md bold-medium">
                  {{
                    amountMask(
                      rentalUnit.Rate.ContractsModels[0].amount as number,
                      rentalUnit.Rate.ContractsModels[0].currency as string,
                    )
                  }}
                </p>
              </div>
            </ion-col>
            <ion-col size="6" class="ion-no-padding">
              <p class="subtitle grey">{{ t('booking.days') }}</p>
              <div class="d-flex align-center">
                <p class="font-md bold-medium">
                  {{ getDays(booking.startDate, booking.endDate) }}
                </p>
              </div>
            </ion-col>
            <ion-col size="6" class="ion-no-padding">
              <p class="subtitle grey">{{ t('booking.people') }}</p>
              <div class="d-flex align-center">
                <ion-icon :icon="people" color="grey"></ion-icon>
                <p class="font-md bold-medium padding-list-item">1</p>
              </div>
            </ion-col>
          </ion-row>
        </ion-card>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IonCard, IonCol, IonIcon, IonItem, IonLabel, IonList, IonRow } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { calendarClearOutline, cardOutline, documentTextOutline, people, chatbubblesOutline } from 'ionicons/icons'; //Importamos icono
import { storeToRefs } from 'pinia';
import router from '@/router';
import { useSearch } from '@/composables/useSearch';
import { Photos, RentalUnit } from '@/interfaces/elastic/elastic.interface';
import RentalUnitCard from '../RentalUnitCard.vue';
import { formatDateTime } from '@/utils/validations/date-utils';
import { useBillingStore } from '@/stores/billing-store';
import { BookingForm, IContractData } from '@/interfaces/booking/booking.interface';
import BookingDetailCard from './BookingDetailCard.vue';
import { amountMask } from '@/utils/validations/formats';
import dayjs from 'dayjs';
import { useCheckInStore } from '@/stores/checkin-store';
import ContractDetailCard from '@/components/my-page/ContractDetailCard.vue';
import { useProfileStore } from '@/stores/profile-store';

withDefaults(
  defineProps<{
    rentalUnit: RentalUnit;
    booking: BookingForm;
    contract: IContractData | undefined;
  }>(),
  {},
);

const { getCurrentName, getCoverImage } = useSearch();
const { invoicesInPage } = storeToRefs(useBillingStore());
const { isChecked, isCheckedOut } = storeToRefs(useCheckInStore());
const { languageSelected } = storeToRefs(useProfileStore());

const { t, locale } = useI18n();

const getDays = (date1: string, date2: string) => {
  const firstDate = new Date(date1);
  const secondDate = new Date(date2);

  // Calculate the difference in milliseconds
  const differenceInMilliseconds = Math.abs(secondDate.getTime() - firstDate.getTime());

  // Convert the difference from milliseconds to days
  return Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));
};

const inWithinDays = (targetDate: string, days: number) => {
  const date = dayjs(targetDate);
  const now = dayjs();
  const fiveDaysBefore = date.subtract(days, 'day');
  return now.isAfter(fiveDaysBefore) && now.isBefore(date);
};

const getPending = () => {
  const invoicesPending = invoicesInPage.value.filter(
    (invoice) => invoice.status === 'pending' || invoice.status === 'sent',
  );

  return invoicesPending.length > 0;
};
</script>

<style lang="scss" scoped>
ion-list {
  width: 100%;
  margin-inline-start: 0 !important;
  margin-inline-end: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  background: white;
  border-radius: 50px;
}

ion-item {
  --background: white;
  border: none;
  padding: 5px;
  --color: var(--ion-color-placeholder);

  font: {
    family: 'Roboto', sans-serif;
    weight: 600;
    size: 15px;
  }
}
</style>
